import {
  ApiResListsType,
  ApiResponseType,
  OhsApiRequestName,
  RequestType,
} from 'global-services/api/OhsApiModels';
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';
import OhsCorrespondenceExchangeRecord from 'correspondence/models/OhsCorrespondenceExchangeRecord';
import OhsHumanResourceTrainingListsRecord, {
  OhsHumanResourceTrainingFilterPayload,
} from 'human-resource/models/OhsHumanResourceTrainingRecord';

import { CommunicationTokenResult, OhsMyCommunicationFilterPayload } from './models/OhsMyHubModel';

export const getMyCommunicationLists = (
  filterInfo: OhsMyCommunicationFilterPayload
): Promise<ApiResponseType<ApiResListsType<OhsCorrespondenceExchangeRecord[]>> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.Correspondence,
    OhsApiRequestName.ListExchange,
    {
      filter: filterInfo,
    }
  );
};

export const getMyCommunicationToken = (
  rollId: string,
  exchangeId: string
): Promise<CommunicationTokenResult | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.Correspondence,
    OhsApiRequestName.ExchangeToken,
    {
      roll: {
        _id: rollId,
      },
      exchange: {
        _id: exchangeId,
      },
    }
  );
};

export const getMyTrainingLists = (
  filterInfo: OhsHumanResourceTrainingFilterPayload
): Promise<ApiResponseType<ApiResListsType<OhsHumanResourceTrainingListsRecord[]>> | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.Training, OhsApiRequestName.List, {
    filter: filterInfo,
  });
};
